import S from './EducationEdit.module.scss';
import C from '../../Resume.module.scss';
import '../../../../../styles/input.scss';
import 'react-datepicker/dist/react-datepicker.css';

import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { MajorSelectedType, SearchType } from '../../../../../types/EducationTypes';
import { useRecoilValue } from 'recoil';
import { IvyAuthorizationTokenAtom } from '../../../../../recoil/Authorization.recoil';
import SearchDropdown from '../../../../common/SearchDropdown';
import { EducationType, ResumeType } from '../../../../../types/ResumeTypes';
import SelectDateBox from '../../../../common/SelectDateBox';
import { DateTimeUtils } from '../../../../../utils/DateTimeUtils';
import { DummyEducation } from '../../../../../constants/IvyConstants';
import _ from 'lodash';
import { ResumeTabsType } from '../../../../../types/ResumeTypes';

// 최종학력 구분 리스트
const finalEducationList = [
  { value: '', name: '학교구분', code: '' },
  { value: 'high-school', name: '고등학교', code: 'EDU_0' },
  { value: 'university', name: '대학교', code: 'EDU_4' },
  { value: 'graduate-school', name: '대학원(석사)', code: 'EDU_5' },
  // { value: 'graduate-school1', name: '대학원(박사)', code: 'EDU_6' },
];

interface EducationEditProps {
  educations: EducationType[];
  setResume: Dispatch<SetStateAction<ResumeType>>;
  resumeTabs: ResumeTabsType;
}

const EducationEdit = (props: EducationEditProps) => {
  const { educations, setResume, resumeTabs } = props;

  const addEducation = (data: EducationType) => {
    setResume((prevResume) => ({ ...prevResume, educations: [...prevResume.educations, data] }));
  };

  const removeEducation = (index: number) => {
    setResume((prevResume) => {
      const updatedEducations = [...prevResume.educations];
      updatedEducations.splice(index, 1); // 해당 index의 요소를 제거
      return {
        ...prevResume,
        educations: updatedEducations,
      };
    });
  };

  useEffect(() => {
    // 없으면 하나 만들어준다.
    if (educations !== undefined && educations.length === 0) {
      // addEducation(makeDummyEducation());
    }
  }, [educations]);

  if (educations === undefined) {
    return null;
  }

  return (
    <>
      <section ref={resumeTabs[1].element} className={`${C.basic_edit_section} wrapper`}>
        <h4 className={`${C.basic_edit_title} h4`}>학력사항 및 대외활동</h4>

        <div className={C.basic_wrap}>
          <div className={C.basic_title}>
            <p className="b1">학력</p>
            <span className={C.red_dot}></span>
          </div>
          <div className={C.basic_input_wrap}>
            {educations?.map((education, index) => {
              return (
                <React.Fragment key={`education-edit-${index}`}>
                  <EducationEditElement index={index} education={education} setResume={setResume} />
                  <button
                    key={`education-btn-${education.name}-${index}`}
                    className={`${C.plus_minus_button} ${C.minus_button}`}
                    onClick={() => {
                      removeEducation(index);
                    }}
                  />
                  <hr />
                </React.Fragment>
              );
            })}
          </div>
        </div>
        <div className={C.plus_button_area}>
          <button
            className={`${C.plus_minus_button} ${C.plus_button}`}
            onClick={() => {
              addEducation(DummyEducation);
            }}
          ></button>
        </div>
        <hr />
      </section>
    </>
  );
};

interface EducationEditElementProps {
  index: number;
  education: EducationType;
  setResume: Dispatch<SetStateAction<ResumeType>>;
}

const EducationEditElement = (props: EducationEditElementProps) => {
  const { index, education, setResume } = props;
  const token = useRecoilValue(IvyAuthorizationTokenAtom);
  const [isGradeFocused, setIsGradeFocused] = useState<boolean>(false);

  const makeDummyEducation = () => {
    return {
      name: '',
      level: '',
      majors: [
        {
          name: '',
          type: 'MAJOR',
        },
      ],
      startAt: '',
      endAt: '',
      grade: '',
      standardOfGrade: '',
    } as EducationType;
  };

  const convertEducationLevelToType = (type: string): SearchType => {
    switch (type) {
      case 'EDU_0':
        return 'high-school';
      case 'EDU_4':
        return 'university';
      case 'EDU_5':
        return 'graduate-school';
      case 'EDU_6':
        return 'graduate-school';
      default:
        return '';
    }
  };

  const updateField = (index: number, fieldName: keyof EducationType, value: string) => {
    setResume((prevResume) => {
      const updatedEducations = [...prevResume.educations];
      updatedEducations[index] = {
        ...updatedEducations[index],
        [fieldName]: value,
      };
      return {
        ...prevResume,
        educations: updatedEducations,
      };
    });
  };

  const updateEducationNameField = (index: number, value: string) => {
    updateField(index, 'name', value);
  };

  const addEmptyMajor = () => {
    updateMajorField(index, '', 'MINOR');
  };

  const removeAdditionalMajor = () => {
    const editingMajors = [...education.majors];
    const indexOfUpdateField = editingMajors.findIndex((e) => e.type === 'MINOR');

    if(indexOfUpdateField > 0){
      editingMajors.splice(1, 1);
      setResume((prevResume) => {
        const updatedEducations = [...prevResume.educations];
        updatedEducations[index] = {
          ...updatedEducations[index],
          majors: editingMajors,
        };
        return {
          ...prevResume,
          educations: updatedEducations,
        };
      });
    }

  };

  const updateMajorField = (index: number, value: string, type: MajorSelectedType) => {
    const editingMajors = [...education.majors];
    const indexOfUpdateField = editingMajors.findIndex((e) => e.type === type);
    if (indexOfUpdateField === -1) {
      if (editingMajors.length === 1) {
        editingMajors.push({ name: value, type: type });
      } else {
        editingMajors[1].name = value;
        editingMajors[1].type = type;
      }
    } else {
      editingMajors[indexOfUpdateField].name = value;
      editingMajors[indexOfUpdateField].type = type;
    }

    setResume((prevResume) => {
      const updatedEducations = [...prevResume.educations];
      updatedEducations[index] = {
        ...updatedEducations[index],
        majors: editingMajors,
      };
      return {
        ...prevResume,
        educations: updatedEducations,
      };
    });
  };

  const updateStartDateField = (value: Date, index: number) => {
    updateField(index, 'startAt', DateTimeUtils.toDateStringYYYYMM(value));
  };

  const updateEndDateField = (value: Date, index: number) => {
    updateField(index, 'endAt', DateTimeUtils.toDateStringYYYYMM(value));
  };

  const initEducation = (level: string) => {
    setResume((prevResume) => {
      const updatedEducations = [...prevResume.educations];
      updatedEducations[index] = makeDummyEducation();
      updatedEducations[index].level = level;
      return {
        ...prevResume,
        educations: updatedEducations,
      };
    });
  };

  if (education === undefined) {
    return null;
  }

  const checkInputValue = () => {
    if (education.grade !== '') {
      setIsGradeFocused(true);
    }
  };

  useEffect(() => {
    checkInputValue();
  }, []);

  return (
    <>
      <div className={S.school_edit_wrap}>
        <div className={`${C.basic_edit_input} ${C.flex_item_center}`}>
          {/* 최종학력 구분 */}
          <select
            className="input-border input-select"
            value={education.level}
            onChange={(e) => {
              initEducation(e.currentTarget.value);
            }}
          >
            {finalEducationList.map((el, idx) => {
              return (
                <option key={el.value} value={el.code}>
                  {el.name}
                </option>
              );
            })}
          </select>
          {/* 기본 or 고등학교 시작 */}
          {convertEducationLevelToType(education.level) == 'high-school' && (
            <>
              <SearchDropdown
                selectedSearchValue={education.name}
                setSelectedSearchValue={updateEducationNameField}
                type={'high-school'}
                token={token}
                selectedValueIndex={index}
              />
              <SelectDateBox
                selectedDate={DateTimeUtils.stringToDateType(education.startAt, 'YYYY-MM')}
                setSelectedDate={updateStartDateField}
                type={'education-entrance-date'}
                index={index}
              />
              <SelectDateBox
                selectedDate={DateTimeUtils.stringToDateType(education.endAt, 'YYYY-MM')}
                setSelectedDate={updateEndDateField}
                type={'education-graduation-date'}
                index={index}
              />
            </>
          )}
          {/* 기본 or 고등학교 끝 */}
          {/* 대학교 시작 */}
          {convertEducationLevelToType(education.level) === 'university' && (
            <>
              <SearchDropdown
                selectedSearchValue={education.name}
                setSelectedSearchValue={updateEducationNameField}
                type={'university'}
                token={token}
                selectedValueIndex={index}
              />
              {/* 학과 */}
              <SearchDropdown
                selectedSearchValue={education.majors.find((e) => e.type === 'MAJOR')?.name || ''}
                setSelectedSearchValue={updateMajorField}
                type={'major'}
                token={token}
                selectedValueIndex={index}
                additionalType={'MAJOR'}
              />

              {/* 학점기준 */}
              <select
                className="input-border input-select"
                value={education.standardOfGrade}
                onChange={(e) => updateField(index, 'standardOfGrade', e.target.value)}
              >
                <option value="">학점기준</option>
                <option value="4.5">4.5</option>
                <option value="4.0">4.0</option>
                <option value="4.3">4.3</option>
                <option value="7.0">7.0</option>
                <option value="100">100</option>
              </select>
              {/* 학점등록 */}
              <div className="input-grp">
                <label
                  htmlFor={`grade_${index}`}
                  className={isGradeFocused ? 'input-label focus-on' : 'input-label'}
                >
                  학점등록
                </label>
                <input
                  type="number"
                  id={`grade_${index}`}
                  className="input-text input-border"
                  onFocus={() => {
                    setIsGradeFocused(true);
                  }}
                  onBlur={(e) => {
                    if (!_.isEmpty(education.grade)) {
                      setIsGradeFocused(true);
                    } else {
                      setIsGradeFocused(false);
                    }
                  }}
                  onChange={(e) => {
                    updateField(index, 'grade', e.target.value);
                    setIsGradeFocused(true);
                  }}
                  value={education.grade}
                />
              </div>

              {/* 졸업여부 */}
              <select
                className="input-border input-select"
                value={education.academicStatus}
                onChange={(e) => {
                  updateField(index, 'startAt', '');
                  updateField(index, 'endAt', '');
                  updateField(index, 'academicStatus', e.target.value);
                }}
              >
                <option value="" defaultChecked>
                  선택
                </option>
                <option value="GRADUATION" defaultChecked>
                  졸업
                </option>
                <option value="IN_SCHOOL">재학</option>
              </select>
              {/* 입학&졸업년월 */}
              <SelectDateBox
                selectedDate={DateTimeUtils.stringToDateType(education.startAt, 'yyyy-MM')}
                setSelectedDate={updateStartDateField}
                type={'education-entrance-date'}
                index={index}
              />
              {education.academicStatus !== 'IN_SCHOOL' && (
                <SelectDateBox
                  selectedDate={DateTimeUtils.stringToDateType(education.endAt, 'yyyy-MM')}
                  setSelectedDate={updateEndDateField}
                  type={'education-graduation-date'}
                  index={index}
                />
              )}
              {/* 다른전공 추가 */}
              {education.majors.length === 1 && (
                <button
                  type="button"
                  className={S.add_major_btn}
                  onClick={() => {
                    addEmptyMajor();
                  }}
                >
                  <p className={`b2 ${S.btn_text}`}>다른 전공 추가</p>
                  <p className={`b1 ${S.btn_icon}`}>+</p>
                </button>
              )}

              {/* 대학교 전공 추가영역 */}
              {education.majors.length === 2 && (
                <>
                  <div className={S.major_wrap}>
                    {/* 전공&부전공 */}
                    <select
                      className="input-border input-select"
                      value={education.majors[1].type}
                      onChange={(e) => {
                        updateMajorField(index, '', e.target.value as MajorSelectedType);
                      }}
                    >
                      <option value="MINOR">부전공</option>
                      <option value="DOUBLE_MAJOR">복수전공</option>
                    </select>
                    {/* 학과 */}
                    <SearchDropdown
                      selectedSearchValue={education.majors[1].name}
                      setSelectedSearchValue={updateMajorField}
                      type={'major'}
                      token={token}
                      selectedValueIndex={index}
                      additionalType={education.majors[1].type}
                    />
                    <button
                      key={`education-additional-major-btn-${index}`}
                      className={`${C.plus_minus_button} ${C.minus_button} ${C.major_minus_button}`}
                      onClick={() => {
                        removeAdditionalMajor();
                      }}
                    />
                  </div>
                </>
              )}
            </>
          )}
          {/* 대학원 시작 */}
          {convertEducationLevelToType(education.level) === 'graduate-school' && (
            <>
              <SearchDropdown
                selectedSearchValue={education.name}
                setSelectedSearchValue={updateEducationNameField}
                type={'graduate-school'}
                token={token}
                selectedValueIndex={index}
              />
              {/* 학과 */}
              <SearchDropdown
                selectedSearchValue={education.majors.find((e) => e.type === 'MAJOR')?.name || ''}
                setSelectedSearchValue={updateMajorField}
                type={'major'}
                token={token}
                selectedValueIndex={index}
                additionalType={'MAJOR'}
              />
              {/* 학점기준 */}
              <select
                className="input-border input-select"
                value={education.standardOfGrade}
                onChange={(e) => updateField(index, 'standardOfGrade', e.target.value)}
              >
                <option value="">학점기준</option>
                <option value="4.5">4.5</option>
                <option value="4.0">4.0</option>
                <option value="4.3">4.3</option>
                <option value="7.0">7.0</option>
                <option value="100">100</option>
              </select>
              {/* 학점등록 */}
              <div className="input-grp">
                <label
                  htmlFor={`graduateSchool_${index}`}
                  className={isGradeFocused ? 'input-label focus-on' : 'input-label'}
                >
                  학점등록
                </label>
                <input
                  type="number"
                  id={`graduateSchool_${index}`}
                  className="input-text input-border"
                  onFocus={() => {
                    setIsGradeFocused(true);
                  }}
                  onBlur={(e) => {
                    if (!_.isEmpty(education.grade)) {
                      setIsGradeFocused(true);
                    } else {
                      setIsGradeFocused(false);
                    }
                  }}
                  onChange={(e) => {
                    updateField(index, 'grade', e.target.value);
                    setIsGradeFocused(true);
                  }}
                  value={education.grade}
                />
              </div>
              {/* 졸업여부 */}
              <select
                className="input-border input-select"
                value={education.academicStatus}
                onChange={(e) => {
                  updateField(index, 'startAt', '');
                  updateField(index, 'endAt', '');
                  updateField(index, 'academicStatus', e.target.value);
                }}
              >
                <option value="" defaultChecked>
                  선택
                </option>
                <option value="GRADUATION" defaultChecked>
                  졸업
                </option>
                <option value="IN_SCHOOL">재학</option>
              </select>

              {/* 입학&졸업년월 */}
              <SelectDateBox
                selectedDate={DateTimeUtils.stringToDateType(education.startAt, 'yyyy-MM')}
                setSelectedDate={updateStartDateField}
                type={'education-entrance-date'}
                index={index}
              />
              {education.academicStatus !== 'IN_SCHOOL' && (
                <SelectDateBox
                  selectedDate={DateTimeUtils.stringToDateType(education.endAt, 'yyyy-MM')}
                  setSelectedDate={updateEndDateField}
                  type={'education-graduation-date'}
                  index={index}
                />
              )}
              {/* 다른전공 추가 */}
              {education.majors.length === 1 && (
                <button
                  type="button"
                  className={S.add_major_btn}
                  onClick={() => {
                    addEmptyMajor();
                  }}
                >
                  <p className={`b2 ${S.btn_text}`}>다른 전공 추가</p>
                  <p className={`b1 ${S.btn_icon}`}>+</p>
                </button>
              )}

              {/* 대학교 전공 추가영역 */}
              {education.majors.length === 2 && (
                <>
                  <div className={S.major_wrap}>
                    {/* 전공&부전공 */}
                    <select
                        className="input-border input-select"
                        value={education.majors[1].type}
                        onChange={(e) => {
                          updateMajorField(index, '', e.target.value as MajorSelectedType);
                        }}
                    >
                      <option value="MINOR">부전공</option>
                      <option value="DOUBLE_MAJOR">복수전공</option>
                    </select>
                    {/* 학과 */}
                    <SearchDropdown
                        selectedSearchValue={education.majors[1].name}
                        setSelectedSearchValue={updateMajorField}
                        type={'major'}
                        token={token}
                        selectedValueIndex={index}
                        additionalType={education.majors[1].type}
                    />
                    <button
                        key={`education-additional-major-btn-${index}`}
                        className={`${C.plus_minus_button} ${C.minus_button} ${C.major_minus_button}`}
                        onClick={() => {
                          removeAdditionalMajor();
                        }}
                    />
                  </div>
                </>
              )}
            </>
          )}
          {/* 대학원끝 */}
        </div>
      </div>
    </>
  );
};

export default EducationEdit;
